import React, { Fragment } from "react";
import Seo from "../Slot/seo";
import { Box, Flex } from "@chakra-ui/react";
import Carousel from "../../components/Carousel/Carousel";
import MobileSearch from "../Search/MobileSearch";
import GameSelector from "../../components/GameComponents/GameSelector/GameSelector";
import MarqueeList from "../../components/marquee/marqueeList";
import TopGameBoard from "../../components/GameComponents/TopGameBoard/TopGameBoard";
import useCheckLogin from "../../hook/useCheckLogin";
import useDeviceType from "../../hook/useDeviceType";
import LeaderBoardWrapper from "../../components/GameComponents/LeaderBoard/LeaderBoardWrapper";
import GameSlideSelector from "../../components/GameComponents/GameSelector/GameSlideSelector";
import HotTypeMenu from "./components/HotTypeMenu/HotTypeMenu";
import TopGameList from "./components/TopGameList";
import JackpotList from "../JackpotList/JackpotList";
import GameSlideSelectorDemo from "../../components/GameComponents/GameSelector/GameSlideSelector.demo";
const Home = () => {
  const { isLogin, isMachineUser, isMachineDomain } = useCheckLogin();

  const isMobile = useDeviceType() === "Mobile";
  const isTablet = useDeviceType() === "Tablet";

  return (
    <Fragment>
      <Box
        minH="unset"
        display="flex"
        flexDirection="column"
      >
        <Box
          // flex="1"
          minH="0" // 這很重要，確保內容不會溢出
          display="flex"
          flexDirection="column"
        >
          <Seo />

          {!isMachineUser ? ( //機台域名不顯示
            <>
              {/* <Box>
                <JackpotListMobile />
              </Box> */}
              <Box
                display={{
                  base: "none",
                  md: "block",
                }}
                my="10px"
              >
                <MarqueeList />
              </Box>
              <Flex
                my={{
                  base: "0px",
                  md: "10px",
                }}
                flexDirection={{
                  base: "column",
                  md: "row",
                }}
                gap={{
                  base: "10px",
                  md: "0px",
                }}
                px={{
                  base: "5px",
                  md: "0px",
                }}
                display={{ base: "flex", xl: "flex" }}
              >
                {!isMobile ? (
                  <LeaderBoardWrapper>
                    <Box
                      w={{
                        base: "100%",
                        md: "350px",
                      }}
                      display={{ base: "none", md: "block" }}
                      mx={{
                        base: "0px",
                        md: "10px",
                      }}
                    >
                      <TopGameBoard />
                    </Box>
                  </LeaderBoardWrapper>
                ) : null}
                <Box
                  as="section"
                  pt={{
                    base: "5px",
                    md: "0px",
                  }}
                  w="100%"
                >
                  <Carousel />
                </Box>
              </Flex>
            </>
          ) : null}
        </Box>
        {/* {isMobile ? (
          <LeaderBoardWrapper>
            <Box
              position="relative"
              zIndex={2}
              w={{
                base: "100%",
                md: "350px",
              }}
              mx={{
                base: "0px",
                md: "10px",
              }}
              my={{
                base: "10px",
                md: "0px",
              }}
            >
              <TopGameBoard />
            </Box>
          </LeaderBoardWrapper>
        ) : null} */}
        <MarqueeList />
        <TopGameBoard />
        <Box mt="10px">
          <JackpotList />
        </Box>
        <Flex direction={"column"} flex={{ base: 1, md: "none" }}>
          <Flex
            overflowX={{
              base: "scroll",
              lg: "hidden",
            }}
            flex={1}
            justifyContent="space-between"
            gap="10px"
          >
            <Box
              flex="none" // 確保這部分不會被拉伸
              w={{
                base: "100%",
              }}
              py={{
                base: 0,
                md: "home-space",
              }}
              mb={{
                base: "60px",
                sm: "0px",
              }}
            >
              {/* 手機板TOP GAME */}
              {isMachineDomain || isMachineUser ? (
                <>
                  <Box>
                    <GameSlideSelector />
                  </Box>
                </>
              ) : (
                <>
                  <Box px="5px">
                    <TopGameList />
                  </Box>
                  <Box px="5px" id="HOT">
                    <GameSelector
                      gameMainTypeFromProps={"HOT"}
                      // hiddenTitle
                      customSubType="Popular"
                      isHighlight
                      sliceCount={10}
                      isHot
                      topLayout={!isMobile && !isTablet}
                      isGridXLayout
                    />
                  </Box>
                  <Box px="5px" id="EXCU">
                    <GameSelector
                      gameMainTypeFromProps={"EXCU"}
                      // hiddenTitle
                      customSubType="exclusiveBrandGames"
                      isHighlight
                      sliceCount={10}
                      isHot
                      // topLayout={!isMobile && !isTablet}
                      isGridXLayout
                    />
                  </Box>
                  <Box px="5px" id="NEW">
                    <GameSelector
                      gameMainTypeFromProps={"NEW"}
                      // hiddenTitle
                      customSubType="New"
                      isHighlight
                      sliceCount={10}
                      isHot
                      // topLayout={!isMobile && !isTablet}
                      isGridXLayout
                    />
                  </Box>
                </>
              )}
            </Box>
          </Flex>
        </Flex>
        {/* {isMachineDomain || isMachineUser ? <JackpotList /> : null} */}
      </Box>
      {isMachineUser || isMachineDomain ? null : (
        <Box
          display={{
            base: "none",
            md: "block",
          }}
        >
          <HotTypeMenu />
        </Box>
      )}
    </Fragment>
  );
};

export default Home;
